/**
 * Substitute `{key}` placeholders in `template` with the matching `vars`
 * values. Returns the original `template` unchanged when no placeholder
 * matches a key. Keys are matched literally — there's no escaping.
 */
export function format(template: string, vars: Record<string, string | number>): string {
  return Object.entries(vars).reduce(
    (out, [key, value]) => out.replace(`{${key}}`, String(value)),
    template,
  );
}
